<template>
    <div class="ps-re">
            <el-select   style="width: 100px"  class="usebutton" v-model="isuse" size="mini"  @change="refreshTree">
                <el-option v-for="item in isuseList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                </el-option>
            </el-select>
        <!--        <el-select @change="kqdataChange" style="width: 150px;margin-left: 20px;flex:1" size="mini" v-model="kqdata" slot="prepend" placeholder="请选择">-->
<!--            <el-option v-for="val in kaoqinList" :key="val.i_id" :label='val.vc_tcname' :value="val.vc_tcname"></el-option>-->
<!--        </el-select>-->
        <div class="tree gdheight mrt10 fitW" id="gdtree">
            <el-tree ref="tree" :data="treeData" lazy :key="treeId" :load="loadNode" :props="defaultProps"
                     node-key="wyid" @node-click="handleNodeClick" :default-expanded-keys="[0]"
                     class="trees  video-tree height100" accordion :highlight-current='true'
                     :expand-on-click-node="false" :show-checkbox="false">
                <div class="custom-tree-node" style="width: 100%"  slot-scope="{ node, data }">
                            <span @contextmenu="showMenuFun($event,node, data)">
    <!--                                <i class="el-icon-folder-opened"></i>-->
                                <!--                                <template v-if="data.type==1">-->
                                <!--                                        <i class="el-icon-folder-opened" style="padding-right: 5px"></i>-->
                                <!--                                </template>-->
                                <!--                                <template v-if="data.type==0">-->
                                <!--                                    <i v-if="data.isMainType==null||data.isMainType==undefined" class="el-icon-document" style="padding-right: 5px"></i>-->
                                <!--                                </template>-->
                                    <span>{{ node.label }}</span>
                                <div v-if="showMenuId==data.i_id" class="menu"  style="z-index: 2">
    <!--          @node-contextmenu="showMenuFun"                   :style="{left:`${menuX}px`,top:`${menuY}px`}"-->
                                    <template>
                                        <div  class="info" v-if="data.i_id||data.i_id==0"  @click.stop="addFun(data,'add')"><i class="el-icon-folder-add" style="margin-right: 8px; transform: rotate(90deg)"></i>{{addMenu}}</div>
                                        <div  class="info" v-if="data.i_id&&data.i_id!=0" @click.stop="addFun(data,'edit')" ><i class="el-icon-edit" style="padding-right: 8px"></i>{{editMenu}}</div>
                                    </template>
                                </div>
                            </span>
                </div>
            </el-tree>
        </div>
    </div>
</template>

<script>
    import * as API from "./../api"
    import {mapActions} from "vuex";
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "index",
        components: {},
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_id'
                },
                treeData:[],
                // kaoqinList:[],
                // kaoqini_id:0,
                // kqdata:'',
                isuse:1,
                isuseList:[{i_id:1,vc_name:'启用'},{i_id:0,vc_name:'未启用'}],
                treeId:0,
                showMenuId:null,
                addMenu:'',
                editMenu:'',
                tableHeight:0,

            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            // this.getKqList()
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })
            let that=this,box=document.getElementById('tabelBox');
            box.addEventListener('mouseup',function (event) {
                if(event.button===0||event.button==2){
                    // console.log('down------------------')
                    that.showMenuId=null

                }
            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3+100;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            showMenuFun(event,node, val){
                event.preventDefault();
                this.showMenuId=val.i_id;
                this.addMenu='新增';
                this.editMenu='编辑';
            },
            addFun(val,type){
                let data=JSON.parse(JSON.stringify(val));
                this.showMenuId=null;
                this.$emit('detailPage',data,type)
            },
            refreshTree(){
                this.treeId=Math.random();
            },
            async getDeptTree({value=0,type='depart'},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:value,
                    i_isuse:this.isuse,
                    isiysuser:1,
                };
                let res = await API.getDeptTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash=one;
                            hash.isLeaf= !one.hasSubDept;
                            hash.i_level= one.i_level;
                            hash.label= one.vc_name;
                            hash.value= one.i_id;
                            hash.wyid= one.i_id+'_'+one.i_pid+'_'+one.nodeType;
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            handleNodeClick(val){
                // console.log(val,'treeData')
                this.showMenuId=null;
                let data=JSON.parse(JSON.stringify(val));
                this.$emit('showData',data)
            },
            loadNode(node, resolve) {
                this.showMenuId=null;
                let _this=this;
                if (node.level === 0) {
                    let val={i_id:0,i_level:0,i_pid:0,label:'全部',vc_name:'全部',children:[],isLeaf:false};
                    return resolve([val]);
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.getDeptTree(node.data,resolve,node.level);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    *{
        font-size: 14px;
    }
    /deep/.el-tree-node__label{
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .ps-re{
        position: relative;

    }
    .fitW{
        width: fit-content;
    }
    .usebutton{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 99;
    }
    /deep/ {
        .el-tree-node__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-tree-node__content{
            width: 100%;
        }
    }
    .menu{
        /*display: flex;*/
        border: 1px solid #8e8e8e;
        right: 0;
        position: absolute;
        background-color: #fff;
        box-shadow:0 2px 8px rgba(0,0,0,0.1);
    }
    .info{
        /*border: 1px solid #8e8e8e;*/
        padding: 5px 15px;
    }
    .info:hover{
        background-color: #CCCCCC;

    }
    .el-tree span{
        display: inline-block;
        width: 100%;
    }
</style>